<template>
	<div>
		<h4 class="mb-15px">基础信息</h4>
		<el-descriptions title="" :column="4">
			<el-descriptions-item label="编号">{{ detail.number }}</el-descriptions-item>
			<el-descriptions-item label="身份类别">{{ idTypeMap[detail.type] }}</el-descriptions-item>
			<el-descriptions-item label="名称">{{ detail.name }}</el-descriptions-item>
			<el-descriptions-item label="联系方式">{{ detail.phone }}</el-descriptions-item>
			<el-descriptions-item label="证件号">{{ detail.idCard }}</el-descriptions-item>
			<el-descriptions-item label="地区">{{ detail.investRegionName }}</el-descriptions-item>
			<el-descriptions-item label="等级">{{ detail.levelName }}</el-descriptions-item>
			<el-descriptions-item label="投资金额">{{ detail.invest }}</el-descriptions-item>
			<el-descriptions-item label="注册时间">{{ detail.createTime | timeFormate }}</el-descriptions-item>
			<el-descriptions-item label="审核时间"></el-descriptions-item>
			<el-descriptions-item label="合同">
			  <a :href="detail.partnerContract | filterImage">点击下载</a>
			</el-descriptions-item>
		</el-descriptions>

		<h4 class="mtb-15px">证件照</h4>
		<div class="photo-list">
			<div class="photo-item" v-for="(item, index) in detail.idPhotos" :key="index">
				<img :src="item | filterImage" @click="$store.commit('SHOW_IMAGE_WALL', item)" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			detail: {
				type: Object,
				default: () => {}
			}
		},

		data() {
			return {
				idTypeMap: {
					1: '合伙人',
					2: '商家',
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
.photo-list {
	display: flex;
	align-items: center;
	.photo-item {
		margin-right: 15px;
		width: 100px;
		cursor: pointer;
		img {
			width: 100%;
		}
	}
}
</style>
